import React from 'react';
import { PRESCRIPTION_STATES } from '~shared/constants';

export const prescriptionActiveStates = [
  PRESCRIPTION_STATES.TOO_EARLY,
  PRESCRIPTION_STATES.ACTIVE,
  PRESCRIPTION_STATES.ACTIVE_RENEWED,
];

export const phoneSupport = '1 (800) 874-5881';
export const PhoneSupport = <a href={`tel:${phoneSupport}`}>{phoneSupport}</a>;
